import request from '@/utils/request'

export function fetchList (query) {
  // page 0 limit 0 for all items
  return request({
    url: '/Category/List?page=0&limit=0',
    method: 'get',
    params: query
  })
}
